import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STAFF_TOKEN_KEY = "spc_staff_token";
const TECH_TOKEN_KEY = "spc_tech_token";
const STAFF_INFO_KEY = "spc_staff_info";
const TECH_INFO_KEY = "spc_tech_info";

export function getStaffToken() {
  return localStorage.getItem(STAFF_TOKEN_KEY);
}
export function getTechToken() {
  return localStorage.getItem(TECH_TOKEN_KEY);
}
export function getStaffInfo() {
  const v = localStorage.getItem(STAFF_INFO_KEY);
  return v ? JSON.parse(v) : null;
}
export function getTechInfo() {
  const v = localStorage.getItem(TECH_INFO_KEY);
  return v ? JSON.parse(v) : null;
}

export function setStaffSession(payload) {
  localStorage.setItem(STAFF_TOKEN_KEY, payload.token);
  localStorage.setItem(STAFF_INFO_KEY, JSON.stringify(payload));
}
export function setTechSession(payload) {
  localStorage.setItem(TECH_TOKEN_KEY, payload.token);
  localStorage.setItem(TECH_INFO_KEY, JSON.stringify(payload.tech));
}
export function clearStaffSession() {
  localStorage.removeItem(STAFF_TOKEN_KEY);
  localStorage.removeItem(STAFF_INFO_KEY);
}
export function clearTechSession() {
  localStorage.removeItem(TECH_TOKEN_KEY);
  localStorage.removeItem(TECH_INFO_KEY);
}

export const apiPublic = axios.create({ baseURL: API });

export const apiStaff = axios.create({ baseURL: API });
apiStaff.interceptors.request.use((cfg) => {
  const t = getStaffToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const apiTech = axios.create({ baseURL: API });
apiTech.interceptors.request.use((cfg) => {
  const t = getTechToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
